import axios from '@/lib/axios';
import { useQuery } from '@tanstack/react-query';
import { PurchaseOrderContractTask } from '@/hooks/api/models';
import queryClient from '@/lib/queryClient';

/**
 * 0820. 発注案件契約タスク詳細
 * [GET] /workspaces/:identifier/teams/:team_id/purchase_orders/:purchase_order_id/purchase_order_contract_tasks/:id
 */
type Props = {
  identifier: string;
  team_id: number;
  purchase_order_id: number;
  id: number;
};
const purchaseOrderContractTask = (props: Props): Promise<PurchaseOrderContractTask> => {
  return axios.get(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/purchase_orders/${props.purchase_order_id}/purchase_order_contract_tasks/${props.id}`
  );
};

export const usePurchaseOrderContractTask = (props: Props) => {
  return useQuery({
    queryKey: queryKey(props),
    queryFn: () => purchaseOrderContractTask(props),
  });
};

export const usePurchaseOrderContractTaskInvalidate = (props: Props) => {
  const invalidate = () => {
    queryClient.invalidateQueries({ queryKey: queryKey(props) });
  };

  return { invalidate };
};

const queryKey = (props: Props) => {
  return ['workspaces', props.identifier, 'teams', props.team_id, 'purchase_orders', props.purchase_order_id, 'purchase_order_contract_tasks', props.id];
};
